export const CATEGORIES = [
  { slug: "tricouri", ro: "Tricouri", en: "T-Shirts" },
  { slug: "hanorace", ro: "Hanorace", en: "Hoodies" },
  { slug: "sepci", ro: "Șepci", en: "Caps" },
  { slug: "ochelari", ro: "Ochelari", en: "Sunglasses" },
  { slug: "portofele", ro: "Portofele", en: "Wallets" },
];

export const catLabel = (slug, lang) => {
  const c = CATEGORIES.find((x) => x.slug === slug);
  return c ? (lang === "ro" ? c.ro : c.en) : slug;
};
